import styled from 'styled-components'
import { TextLinkButton } from './shared.styles'
import { motion } from '@/theme/tokens'

/**
 * The step's content column, phone-width like the iOS screen: heading row and
 * calendar share it, so the heading's left edge lines up with the card's.
 */
export const StepColumn = styled.div`
	max-width: 440px;
	margin: 0 auto;
`

export const HeadingRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
`

/**
 * "Clear" only means something once a date is picked, so it shows up with the
 * date. It keeps its place in the row when hidden — fading rather than
 * unmounting is what stops the heading and calendar shifting as the date comes
 * and goes (same call as iOS).
 */
export const ClearButton = styled(TextLinkButton)`
	transition: opacity ${motion.fast};

	&:disabled {
		opacity: 0;
	}
`
